import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import { Bar } from 'react-chartjs-2';

export default function VerticalBarChart({ chartData, monthly, color, title, ratio, bp }) {
    ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                    drawBorder: false
                }
            },
            y: {
                grid: {
                    display: false,
                    drawBorder: false
                },
                title: {
                    display: true,
                    text: title,
                    font: {
                        size: '11',
                        weight: '500'
                    },
                    padding: {
                        bottom: 8
                    }
                },
            }
        },
        aspectRatio: ratio || 2.4
    }

    const labels = chartData?.map((label) => {
        const date = new Date(Number(label.Year), Number(label.Month) - 1, 1)

        return date.toLocaleString('en-US', { month: 'short' })
        // return date.toLocaleString('en-US', { month: 'short', year: 'numeric' })
    })

    const datas = chartData?.map((label) => {
        return label.CommissionTotalSum
    })

    const data = {
        labels,
        datasets: [
            {
                label: title,
                data: datas,
                // data: chartData?.data,
                backgroundColor: color,
                borderSkipped: false,
                borderRadius: 100,
                barPercentage: bp || 0.2
            },
        ],
    }

    return <Bar options={options} data={data} />
}